module.exports = __webpack_public_path__ + "static/media/whatsapp.8e6f5bd9.svg";